<div class="my-5 mx-3 d-flex flex-column flex-grow-1 sidebar-height">
  <div
    *transloco="let t"
    class="menu menu-column menu-rounded menu-sub-indention fw-semibold fs-6 flex-grow-1"
  >
    @for (item of menuItems(); track item) {
      @if (!item.adminCredentials) {
        <div class="menu-item">
          @if ((item?.subItems?.length ?? 0) > 0) {
            <div class="bg-transparent border-0" ngbAccordion>
              <div
                ngbAccordionItem
                [collapsed]="item.link !== activeItem()"
                class="bg-transparent border-0"
              >
                <div class="bg-transparent border-0" ngbAccordionHeader>
                  <button
                    class="menu-link bg-transparent border-0 outline-0 shadow-none"
                    ngbAccordionButton
                  >
                    <span class="menu-icon">
                      <ui-keenicon
                        [name]="item?.icon!"
                        class="fs-2"
                      ></ui-keenicon>
                    </span>
                    <span class="menu-title text-nowrap"
                      >{{ t(item?.titleKey!) }}
                    </span>
                  </button>
                </div>
                <div class="border-0" ngbAccordionCollapse>
                  <div
                    class="border-0 pb-0 pt-2 accordion-body-custom"
                    ngbAccordionBody
                  >
                    @for (subItem of item.subItems!; track subItem) {
                      <div>
                        @if (subItem?.link && subItem?.titleKey) {
                          @if (!subItem?.locked) {
                            <a
                              class="menu-link without-sub"
                              routerLinkActive="active"
                              [routerLink]="[subItem?.link]"
                              [routerLinkActiveOptions]="{
                                exact:
                                  subItem.routerLinkActiveOptions?.exact ||
                                  subItem?.link === '/',
                              }"
                              (click)="activeOffcanvas.close()"
                            >
                              <span class="menu-icon">
                                <ui-keenicon
                                  [name]="subItem?.icon!"
                                  class="fs-5"
                                />
                              </span>
                              <span class="menu-title text-nowrap">{{
                                t(subItem?.titleKey!)
                              }}</span>
                            </a>
                          } @else {
                            <a
                              class="menu-link without-sub"
                              (click)="onLockedItemClick()"
                              (keyup.enter)="onLockedItemClick()"
                              tabindex="0"
                              role="button"
                            >
                              <span class="menu-icon">
                                <ui-keenicon
                                  [name]="subItem?.icon!"
                                  class="fs-2"
                                ></ui-keenicon>
                              </span>
                              <span class="menu-title text-nowrap">{{
                                t(subItem?.titleKey!)
                              }}</span>
                              @if (subItem?.locked) {
                                <ui-keenicon
                                  name="lock-2"
                                  class="fs-2"
                                ></ui-keenicon>
                              }
                            </a>
                          }
                        }
                      </div>
                    }
                  </div>
                </div>
              </div>
            </div>
          } @else {
            @if (item?.href && !item?.locked) {
              <a
                class="menu-link without-sub"
                [href]="item.href"
                target="_blank"
                (click)="activeOffcanvas.close()"
              >
                @if (item?.image) {
                  <span class="menu-icon">
                    <img [src]="item.image" class="image-menu" alt="image" />
                  </span>
                  <span class="menu-title text-nowrap">{{
                    t(item?.titleKey!)
                  }}</span>
                  @if (item?.locked) {
                    <ui-keenicon name="lock-2" class="fs-2"></ui-keenicon>
                  }
                } @else {
                  <span class="menu-icon">
                    <ui-keenicon
                      [name]="item?.icon!"
                      class="fs-2"
                    ></ui-keenicon>
                  </span>
                  <span class="menu-title text-nowrap">{{
                    t(item?.titleKey!)
                  }}</span>
                }
              </a>
            } @else {
              @if (!item?.locked) {
                <a
                  class="menu-link without-sub"
                  routerLinkActive="active"
                  [routerLink]="[item?.link]"
                  [routerLinkActiveOptions]="
                    item?.routerLinkActiveOptions || { exact: false }
                  "
                  (click)="activeOffcanvas.close()"
                >
                  @if (item?.image) {
                    <span class="menu-icon">
                      <img [src]="item.image" class="image-menu" alt="image" />
                    </span>
                    <span class="menu-title text-nowrap">{{
                      t(item?.titleKey!)
                    }}</span>
                  } @else {
                    <span class="menu-icon">
                      <ui-keenicon
                        [name]="item?.icon!"
                        class="fs-2"
                      ></ui-keenicon>
                    </span>
                    <span class="menu-title text-nowrap">{{
                      t(item?.titleKey!)
                    }}</span>
                  }
                </a>
              } @else {
                <a
                  class="menu-link without-sub"
                  (click)="onLockedItemClick()"
                  (keyup.enter)="onLockedItemClick()"
                  tabindex="0"
                  role="button"
                >
                  @if (item?.image) {
                    <span class="menu-icon">
                      <img [src]="item.image" class="image-menu" alt="image" />
                    </span>
                    <span class="menu-title text-nowrap"
                      >{{ t(item?.titleKey!) }}
                    </span>
                    @if (item?.locked) {
                      <ui-keenicon name="lock-2" class="fs-2"></ui-keenicon>
                    }
                  } @else {
                    <span class="menu-icon">
                      <ui-keenicon
                        [name]="item?.icon!"
                        class="fs-2"
                      ></ui-keenicon>
                    </span>
                    <span class="menu-title text-nowrap">{{
                      t(item?.titleKey!)
                    }}</span>
                    @if (item?.locked) {
                      <ui-keenicon name="lock-2" class="fs-2"></ui-keenicon>
                    }
                  }
                </a>
              }
            }
          }
        </div>
      }
    }
  </div>
</div>
<div class="app-sidebar-footer mt-auto flex-column-auto pt-2 pb-6 px-6">
  <ui-sidebar-footer [PAGE_ROUTES]="PAGE_ROUTES()"></ui-sidebar-footer>
</div>
